import EzController from 'controllers/ez-base-controller';
import $script from 'scriptjs';
import Cookies from 'js-cookie';
import axios from 'axios';
import {
  fromSignup,
  removeSocialOauthCookie,
} from 'lib/social-session-helpers';
import { INIT_GOOGLE_ONE_TAP } from 'lib/ez-custom-events';
import {
  sendTrackingEvent,
  trackCompleteEvent,
} from 'components/analytics/conversions/tracking';
import { JOIN_COMPLETE, LOGIN_COMPLETE, JOIN_LOGIN_TRIGGERED } from 'components/analytics/conversions/constants/actions';

type GoogleIdContext = 'signin' | 'signup' | 'use';

export default class GoogleOneTapController extends EzController {
  declare clientId:string

  connect() {
    this.clientId = this.element.dataset.clientId;

    const libUrl = this.element.dataset.googleSigninUrl;

    $script(libUrl, () => {
      this.initOneTap();
      this.flagLoaded();
    });

    window.addEventListener(INIT_GOOGLE_ONE_TAP, this.initOneTap);
  }

  disconnect() {
    window.removeEventListener(INIT_GOOGLE_ONE_TAP, this.initOneTap);
  }

  initOneTap = () => {
    const idConfig = {
      client_id: this.clientId,
      callback: this.handleCredentialResponse,
      context: this.element.dataset.context as GoogleIdContext,
      state_cookie_domain: this.element.dataset.stateCookieDomain,
      auto_select: this.element.dataset.autoSelect === 'true',
    };

    google.accounts.id.initialize(idConfig);

    google.accounts.id.prompt(this.sendDialogTriggerEvent);
  }

  sendDialogTriggerEvent = (notification) => {
    if (!notification.isDisplayed()) return;

    sendTrackingEvent({
      element: this.element,
      data: { action: JOIN_LOGIN_TRIGGERED, non_interaction: true },
    });
  }

  handleCredentialResponse = (response) => {
    const url = this.element.dataset.loginUri;

    Cookies.set('g_csrf_token', this.csrfToken);

    axios.defaults.headers.common['X-CSRF-Token'] = this.csrfToken;

    return axios.post(`${url}?sign_in_type=one_tap&credential=${response.credential}&g_csrf_token=${this.csrfToken}`, response).then((res) => {
      if (!res.request.responseURL.includes('google_one_tap')) {
        window.location.assign(res.request.responseURL);
        return;
      }

      if ((res.status === 200 || res.status === 204)) {
        // using the social_oauth_type cookie to check if it's a sign in
        if (fromSignup()) {
          // we have to eval the modal injector code coming back
          eval(res.data); // eslint-disable-line no-eval

          trackCompleteEvent({
            action: JOIN_COMPLETE,
            category: 'Trigger-One_Tap',
            label: 'Sign_Up-One_Tap',
            dataLayerCompleteAttrs: [
              'email_address',
              'email_hash_md5',
              'email_hash_sha1',
              'sign_in_type',
            ],
          });
        } else {
          if (Cookies.get('sign_in_referrer')) {
            window.location.assign(Cookies.get('sign_in_referrer'));
          } else {
            window.location.reload();
          }

          trackCompleteEvent({
            action: LOGIN_COMPLETE,
            category: 'Trigger-One_Tap',
            label: 'Sign_In-One_Tap',
            dataLayerCompleteAttrs: [
              'email_address',
              'email_hash_md5',
              'email_hash_sha1',
              'sign_in_type',
              'name',
              'country',
              'postal_code',
              'team_owner_email',
              'team_seats',
              'multiple_logins',
            ],
          });
        }
      }

      removeSocialOauthCookie();
    });
  }
}
